import { createContext, useContext } from 'react';

export type ShopperBootstrapStatus = 'pending' | 'ready' | 'failed';

export const ShopperBootstrapContext = createContext<ShopperBootstrapStatus>('pending');

export function getShopperBootstrapStatus(
  accountId: string | undefined,
  login: { variables?: string; isSuccess?: boolean; isError?: boolean },
  lookupFailed = false,
): ShopperBootstrapStatus {
  if (!accountId) return 'pending';
  if (lookupFailed || (login.variables === accountId && login.isError)) return 'failed';
  return login.variables === accountId && login.isSuccess ? 'ready' : 'pending';
}

export default function useShopperBootstrap() {
  return useContext(ShopperBootstrapContext);
}
